import { createFileRoute } from "@tanstack/react-router";
import { BrancherIndexPage, brancherHead } from "@/pages/BrancherIndexPage";

export const Route = createFileRoute("/brancher/")({
  head: () => brancherHead("da"),
  component: () => <BrancherIndexPage locale="da" />,
});
